import tw from 'twin.macro'

export const TwCardHome = tw.div`bg-light-placeholder relative p-4 flex flex-col justify-between`
export const TwAbsoluteCenter = tw.div`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2`
export const TwFlexCenter = tw.div`flex justify-between items-center`
export const TwFlexBetween = tw.div`flex justify-between items-center`
export const TwTitle = tw.p`text-2xl lg:font-bold text-center text-light-secondary lg:text-gray-800 mb-6`
export const TwTitleCardHome = tw.span`text-2xl text-[#363D49] w-full font-semibold`
